import Lottie from "lottie-react";

interface LottieIconProps {
  /** Imported animation JSON (e.g. `import data from "../assets/x-lottie.json"`) */
  animationData: object;
  className?: string;
}

// Single generic renderer for every hand-authored Lottie icon on the page.
// Each animation's artwork is pre-fit to its own canvas edge at the asset
// level (see scripts/lottie-normalize.js), so this just renders it — no
// per-icon crop scale needed.
const LottieIcon = ({ animationData, className = "" }: LottieIconProps) => (
  <span className={`inline-flex overflow-hidden ${className}`}>
    <Lottie animationData={animationData} loop autoplay className="w-full h-full" />
  </span>
);

export default LottieIcon;
